export default __webpack_public_path__ + "static/media/mo.ea150985.jpg";